import { defineMessages } from 'react-intl';

export default defineMessages({
  displayNamePlaceholder: {
    id: 'signup.form.displayName.placeholder',
    defaultMessage: 'Enter full name',
  },
  fullNameLabel: {
    id: 'signup.form.fullName.label',
    defaultMessage: 'Full name',
  },
  emailAddressVerifiedLabel: {
    id: 'welcome.form.email.address.verified.label',
    defaultMessage: 'Verified',
  },
  passwordPlaceholder: {
    id: 'signup.form.password.placeholder',
    defaultMessage: 'Create password',
  },
  passwordLabelNew: {
    id: 'signup.form.password.label.new',
    defaultMessage: 'Password',
  },
});
